<template>
    <b-modal
        ref="dialog"
        title-tag="h2"
        title="Add Plan Item"
        :lazy="true"
        @hidden="close"
    >
        <b-form-group label-cols="3" label="Item:" label-for="with">
            <vue-select
                placeholder="Select plan item"
                v-model="items"
                label="name"
                :options="options"
                multiple
            />
        </b-form-group>

        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isSaving"
                variant="primary"
                @click="save"
                :disabled="items.length === 0"
            >
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import vueSelect from "vue-select";
import axios from "axios";
import Loader from "@/module/commons/loader";

export default {
    components: {
        vueSelect,
        Loader
    },
    data() {
        return {
            patientId: null,
            items: [],
            options: [],
            isLoadingOptions: true,
            isSaving: false
        };
    },
    methods: {
        open(patientId) {
            this.patientId = patientId;
            this.$refs.dialog.show();
            this.fetchOptions(patientId);
        },
        close() {
            this.$refs.dialog.hide();
        },
        async fetchOptions(patientId) {
            try {
                this.isLoadingOptions = true;

                const res = await axios.get(
                    `${process.env.RECORD_SERVICE}filter-medical-record-item/${patientId}`
                );

                const response = res.data.response;

                if (response.message && response.message.code === 200) {
                    this.options = response.resources;
                    this.isLoadingOptions = false;
                } else {
                    throw new Error("Unable to fetch options");
                }
            } catch (e) {
                this.isLoadingOptions = false;
                this._message(e.message, "danger");
            }
        },
        async save() {
            try {
                let selectedItemsIds = [];

                for (const item of this.items) {
                    selectedItemsIds.push(item.id);
                }

                this.isSaving = true;

                const res = await axios.post(
                    process.env.PATIENT_SERVICE + "current-plan",
                    {
                        patient_id: this.patientId,
                        item_ids: selectedItemsIds
                    }
                );

                if (
                    res.data.response &&
                    res.data.response.message &&
                    res.data.response.message.code === 200
                ) {
                    this._message("Plan item successfully added.");
                    this.close();
                    this.$emit("onsuccess");
                } else {
                    throw new Error("Unable to add item.");
                }
            } catch (e) {
                this.isSaving = false;
                this._message(e.message, "danger");
            }
        }
    }
};
</script>
